import { render } from "./UnPaidSBP.vue?vue&type=template&id=7b59c33c"
import script from "./UnPaidSBP.vue?vue&type=script&lang=js"
export * from "./UnPaidSBP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__